import { useCallback } from 'react';
import { Autocomplete } from 'components/helpers/AlgoliaSearch/Autocomplete';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { IsNmdpSite } from 'lib/util/site-configuration';
import { menuLocation, pageNavigationDataLayerPush } from 'lib/util/gtm-datalayer';

interface IMyProps {
  searchplaceholderText: string;
}

const Search = ({ searchplaceholderText }: IMyProps): JSX.Element => {
  const context = useSitecoreContext();
  const Placeholdertext = searchplaceholderText;

  const searchPageUrl = context.sitecoreContext.searchPageUrl || '';
  const isOnSearchPage = context.sitecoreContext.hasSearch === true;
  const onSubmit = useCallback(
    ({ state }) => {
      // No-op on empty submit
      const querystring = (state.query || '').trim();
      pageNavigationDataLayerPush(querystring, menuLocation[5]);
      if (querystring.length > 0) {
        // We use this to remove any existing querystring (such as when accessed from Sitecore)
        // We don't use the domain but it is required for the URL object.
        const url = new URL(searchPageUrl, 'http://not-used.com');

        // eslint-disable-next-line no-restricted-globals
        location.href = `${url.pathname}?query=${encodeURIComponent(querystring)}`;
      }
    },
    [searchPageUrl]
  );

  return (
    <>
      {IsNmdpSite() && isOnSearchPage ? (
        <Autocomplete
          detachedMediaQuery="none"
          openOnFocus
          asSearchBox
          placeholder={Placeholdertext}
        />
      ) : (
        <Autocomplete
          detachedMediaQuery="none"
          openOnFocus
          onSubmit={onSubmit}
          placeholder={Placeholdertext}
        />
      )}
    </>
  );
};
export default Search;
